// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/lift-pressure-and-downwash.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/lift-pressure-and-downwash/lift-pressure-and-downwash.js';

mount([g0]);
